"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var Track = /** @class */ (function () {
    function Track(config) {
        this.config = config;
        this.date = Date.now();
        this.enabled = false;
        this.sent = [];
        this.api = window[config.params.apiName];
        if (!this.api) {
            console.error("framily api not avilable: \"window." + this.config.params.apiName + "\"");
        }
        else if (!this.api.hasOwnProperty('sendEvent')) {
            console.error("method for event tracking not avilable: \"window." + this.config.params.apiName + ".sendEvent\"");
        }
        else {
            this.enabled = true;
        }
    }
    Track.prototype.track = function (fieldsObject, once) {
        if (once === void 0) { once = false; }
        var comparisonObject = typeof once === 'object' ? once : fieldsObject;
        if ((once && this.wasSent(comparisonObject)) || !this.enabled) {
            return;
        }
        fieldsObject = Object.assign({ eventCategory: "Konfitracking_" + this.config.configJson.id }, fieldsObject);
        this.api.sendEvent(fieldsObject);
    };
    Track.prototype.wasSent = function (fieldsObject) {
        fieldsObject = this.sortObject(fieldsObject);
        for (var _i = 0, _a = this.sent; _i < _a.length; _i++) {
            var entry = _a[_i];
            if (JSON.stringify(fieldsObject) === JSON.stringify(entry)) {
                return true;
            }
        }
        this.sent.push(fieldsObject);
        return false;
    };
    Track.prototype.sortObject = function (unordered) {
        var ordered = {};
        Object.keys(unordered).sort().forEach(function (key) {
            ordered[key] = unordered[key];
        });
        return ordered;
    };
    return Track;
}());
exports.Track = Track;
exports.default = angular.module('pb.track', [])
    .service('track', Track);
